import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=2af855e0"
import script from "./Patient.vue?vue&type=script&lang=ts"
export * from "./Patient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports